var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadcastOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 7.33329C8.7367 7.33329 9.33366 6.73634 9.33366 5.99996C9.33366 5.26358 8.7367 4.66663 8.00033 4.66663C7.26395 4.66663 6.66699 5.26358 6.66699 5.99996C6.66699 6.73634 7.26395 7.33329 8.00033 7.33329Z",
    stroke: "#80421A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8269 3.17341C11.1988 3.5449 11.4938 3.98606 11.6951 4.47165C11.8964 4.95724 12 5.47775 12 6.00341C12 6.52907 11.8964 7.04958 11.6951 7.53517C11.4938 8.02076 11.1988 8.46192 10.8269 8.83341M5.17354 8.82674C4.80163 8.45525 4.5066 8.0141 4.3053 7.5285C4.104 7.04291 4.00039 6.5224 4.00039 5.99674C4.00039 5.47108 4.104 4.95057 4.3053 4.46498C4.5066 3.97939 4.80163 3.53824 5.17354 3.16674M12.7135 1.28674C13.9633 2.53693 14.6654 4.23232 14.6654 6.00008C14.6654 7.76784 13.9633 9.46322 12.7135 10.7134M3.28687 10.7134C2.03706 9.46322 1.33496 7.76784 1.33496 6.00008C1.33496 4.23232 2.03706 2.53693 3.28687 1.28674",
    stroke: "#80421A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastOrange);
export default __webpack_public_path__ + "static/media/broadcast-orange.00bb366e5e1b6466bcac1cd366822e35.svg";
export { ForwardRef as ReactComponent };